import * as angular from "angular";
import {IController} from "angular";
import {PackageConfigurationEntity} from "../../models/package-configuration.model";
import {PackageFieldConfigurationModel} from "../../models/package-field-configuration.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {SettingsService} from "../../services/settings-service.service";
import {ValidationType} from "../../types/validation.type";


export class PackageConfigurationsViewComponent implements IController {

  sitePackageItems: any;

  public packageConfigurations: PackageConfigurationEntity[]
  public packageConfigurationCopy: PackageConfigurationEntity
  public editConfigurationIndex: number;
  public isNewConfiguration: boolean = false;
  public isFetchingConfigurations: boolean = false;
  public isSaveAvailable: boolean = false;
  public loading: boolean = false;

  constructor(private settingsService: SettingsService, private splitService: SplitService) {
  }

  $onInit() {
    this._init();
  }


  private _init() {

    this.packageConfigurations = [];

    this.isFetchingConfigurations = true;
    this.settingsService.getAllPackageConfigurations()
      .then((packageConfigurations: PackageConfigurationEntity[]) => {
        this.packageConfigurations = packageConfigurations;
      })
      .finally(() => {
        this.isFetchingConfigurations = false
        const sitePackageConfiguration = this.splitService.getSiteDefaultPackageConfiguration();
        this.packageConfigurations.push(sitePackageConfiguration)
      })
  }


  onEditPackageConfigurationClicked(index) {
    this.packageConfigurationCopy = angular.copy(this.packageConfigurations[index]);
    this.editConfigurationIndex = index;
  }

  onPackageConfigurationChanged(updatedPackageConfiguration: PackageConfigurationEntity) {
    this.packageConfigurationCopy = updatedPackageConfiguration;
    this.isSaveAvailable = true;
  }

  saveConfiguration(form, isNewConfiguration) {
    this.packageConfigurationCopy.fields.forEach((field, i) => {
      // form[`package${i}`].fieldName.$setValidity('uniq', true);
      if (field.validation.expression) {
        form[`package${i}`].expression.$setValidity('validRegex', true);
      }
    })

    this.packageConfigurationCopy.fields.forEach((field, i) => {

      // Uniqueness of the field names
      this.packageConfigurationCopy.fields.forEach((field2, i2) => {
        if (i !== i2) {
          if (field.name === field2.name) {

            // form[`package${i}`].fieldName.$setValidity('uniq', false);
            // form[`package${i2}`].fieldName.$setValidity('uniq', false);
          }
        }
      })

      //regex validation
      if (field.validation.type === ValidationType.RegularExpression) {
        let isValid = true;
        try {
          new RegExp(field.validation.expression);
        } catch (e) {
          isValid = false;
        } finally {
          if (!isValid) {
            form[`package${i}`].expression.$setValidity('validRegex', false);
          }
        }
      }


    })
    form.$setSubmitted(true);
    if (form.$valid) {
      this.loading = true;
      isNewConfiguration ? this._createNewConfiguration() : this._updateConfiguration();
    }

  }

  onAddNewField() {
    this.packageConfigurationCopy.fields.unshift({validation: {enabled: false}} as PackageFieldConfigurationModel)
    this.packageConfigurationCopy = angular.copy(this.packageConfigurationCopy);
    this.isSaveAvailable = true;
  }

  onDuplicateConfigurationClicked(packageConfiguration: PackageConfigurationEntity, index: number) {
    packageConfiguration = angular.copy({fields: packageConfiguration.fields, name: packageConfiguration.name});
    this.editConfigurationIndex = index;
    const configurationCopy = this.packageConfigurations;
    configurationCopy.splice(index, 0, packageConfiguration);
    this.packageConfigurationCopy = configurationCopy[this.editConfigurationIndex]
    this.isNewConfiguration = true;
  }

  public onAddNewPackageConfiguration() {
    this.editConfigurationIndex = 0;
    const packageConfiguration: PackageConfigurationEntity = {
      name: "",
      fields: [],
    };
    const configurationCopy = this.packageConfigurations;
    configurationCopy.unshift(packageConfiguration);
    this.packageConfigurationCopy = configurationCopy[this.editConfigurationIndex]
    this.onAddNewField();

    this.isNewConfiguration = true;
  }

  private _updateConfiguration() {
    this.settingsService.updatePackageConfiguration(this.packageConfigurationCopy)
      .then((packageConfiguration: PackageConfigurationEntity) => {
        const index = this.packageConfigurations.findIndex((ps) => ps.id === packageConfiguration.id)
        this.packageConfigurations[index] = packageConfiguration;
        this._setToViewMode();
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _createNewConfiguration() {
    this.settingsService.createPackageConfiguration(this.packageConfigurationCopy)
      .then((packageConfiguration: PackageConfigurationEntity) => {
        const packageConfigurationsCopy = angular.copy(this.packageConfigurations)
        packageConfigurationsCopy.unshift(packageConfiguration);
        this.packageConfigurations = packageConfigurationsCopy;
        this._setToViewMode();
        this.isNewConfiguration = false;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _setToViewMode() {
    this.editConfigurationIndex = undefined;
    this.packageConfigurationCopy = undefined;
    this.isSaveAvailable = false;
  }

  public onCancelChanges() {
    this.packageConfigurationCopy = angular.copy(this.packageConfigurations[this.editConfigurationIndex]);
    this.isSaveAvailable = false;
    this.editConfigurationIndex = undefined;
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationsView', {
    bindings: {
      sitePackageItems: '<'
    },
    template: require('./package-configurations-view.html').default,
    controller: PackageConfigurationsViewComponent
  });
